import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const ContentSection = lazy(() => import("./ContentSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const FeatureSection = lazy(() => import("./FeatureSection"));

const EnterpriseApplication = () => {
  return (
    <>
      <Helmet>
        <title>
          Enterprise Application Solutions | Scalable Software for Business
          Efficiency
        </title>
        <meta
          name="description"
          content="Boost your business efficiency with LENTERA’s enterprise applications. Our scalable solutions, including CRM, BI, and cloud-based systems, streamline processes, enhance automation, and improve data management for sales, finance, and customer service teams."
        />
        <meta
          name="keywords"
          content="LENTERA enterprise applications, business process optimization, enterprise software development."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <section className="w-full bg-[#F8F8F8] font-poppins">
          <ContentSection />
          <BenefitSection />
          <FeatureSection />
        </section>
      </Suspense>
    </>
  );
};

export default EnterpriseApplication;
